import { useEffect, useState } from "react";

import api from "../../../../api/api";

export const useGetStates = () => {
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await api.get("/api/all/states/");
        setStates(response.data.data || []);
      } catch (error) {
        console.error("Error fetching states:", error);
        setError(error.message || "Failed to fetch states");
        setStates([]); // Reset to empty array on error
      } finally {
        setLoading(false);
      }
    };

    fetchStates();
  }, []);

  return {
    states,
    loading,
    error,
  };
};
